module.exports = __webpack_public_path__ + "img/2.665ad8a7.jpg";